import {
  Button,
  Flex,
  Paper,
  Text,
  Loader,
  PasswordInput,
  Box,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayInfoMessage,
} from "../shared/ErrorMessage";
import { initialize, updateField, reset } from "../slices/form/password";
import { useEffect } from "react";
import { useAuth } from "../authentication/AuthProvider";
import { IsBlockNav, SetBlockNav } from "../App";
import { updatePassword } from "firebase/auth";

interface Props {
  onClose: () => void;
}
const Password = (props: Props) => {
  const authContext = useAuth();
  const { data, hasChanges } = useAppSelector(
    (state: RootState) => state.passwordForm
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initialize({ password: "" }));
  }, []);

  useEffect(() => {
    // During development useEffect is called twice by React.
    // We need to protect against that by returning if hasChanges didn't change
    if (IsBlockNav() === hasChanges) return;
    if (hasChanges) {
      SetBlockNav(true);
    } else {
      // Can happen if we support undo
      SetBlockNav(false);
    }
  }, [hasChanges]);

  const handleChangePassword = async () => {
    if (data == null) {
      console.error("Data is null but should not be");
      return;
    }
    if (authContext?.user == null) {
      console.error("User is null but should not be");
      return;
    }
    try {
      await updatePassword(authContext.user, data.password);
      displayInfoMessage("Your password was changed.");
      props.onClose();
    } catch (error) {
      console.log(error);
      displayErrorMessage(
        "Your new password must be at least 10 characters in length and must have a numeric and a special character. For security reasons, you may also need to logout and then login again to set a password."
      );
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  return (
    <form onSubmit={(event) => event.preventDefault()}>
      <Paper>
        <Text size="lg">Set Password</Text>
        <Box mt="md" style={{ width: "300px" }}>
          You will still be able to log in via an email link even if you set or
          change your password here. Note that if you logged in more than about
          5 minutes ago, then you may be asked logoff and on again before
          setting or changing your password here.
        </Box>
        <PasswordInput
          mt="sm"
          label="Password"
          style={{ width: "300px" }}
          value={data.password ?? ""}
          onChange={(v) => {
            dispatch(
              updateField({
                field: "password",
                value: v.currentTarget.value,
              })
            );
          }}
        />
        <Flex justify="flex-end">
          <Button
            mt="md"
            mr="md"
            onClick={() => {
              props.onClose();
              dispatch(reset());
            }}
          >
            Cancel
          </Button>
          <Button mt="md" onClick={handleChangePassword} disabled={!hasChanges}>
            Save
          </Button>
        </Flex>
      </Paper>
    </form>
  );
};

export default Password;
